import { Divider as AntDivider } from 'antd';
import styled from 'styled-components';

export const FormWrapper = styled.div`
  flex: 1;
  width: 100%;
  max-width: 318px;
  padding-top: 6px;
`;

export const Divider = styled(AntDivider)`
  border-block-start-color: ${(props) => props.theme.Divider.mainColor};
`;
